import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useChat } from "../../contexts/ChatProvider";
import { useLocale } from "../../contexts/LocaleProvider";

export default function FeedbackModal({
  open,
  type,
  conversation_id,
  onClose,
}) {
  const { t } = useLocale();
  const [message, setMessage] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [closing, setClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(open);
  const { 
    theme,
    submitFeedback, 
    submitFeedbackLoading, 
    submitFeedbackError, 
    setSubmitFeedbackError, 
    setSubmitFeedbackLoading, 
    submitFeedbackSuccess,
    setSubmitFeedbackSuccess,
    negFeedbackOptions,
    posFeedbackOptions,
    posFeedbackSuccessMessage,
    negFeedbackSuccessMessage
  } = useChat();

  const feedbackOptions = type === "up" ? posFeedbackOptions : negFeedbackOptions;
  const showResultState = !submitFeedbackLoading && (submitFeedbackError || submitFeedbackSuccess);
  const [displayResultState, setDisplayResultState] = useState(showResultState);
  const [contentFading, setContentFading] = useState(false);
  // console.log("posFeedbackSuccessMessage = ", posFeedbackSuccessMessage, typeof(posFeedbackSuccessMessage))
  useEffect(() => {
    if (showResultState !== displayResultState) {
      setContentFading(true);
      const timer = setTimeout(() => {
        setDisplayResultState(showResultState);
        setContentFading(false);
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [showResultState]);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setClosing(false);
    } else if (shouldRender) {
      setClosing(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        setClosing(false);
        setMessage("");
      }, 180);
      return () => clearTimeout(timer);
    }
  }, [open]);

  useEffect(() => {
    setDisabled(message.trim() === "");
  }, [message]);

  if (!shouldRender) return null;

  const handleSubmit = () => {
    if (message.trim() !== "") {
      submitFeedback(
        conversation_id,
        type === "up" ? "positive" : "negative",
        message
      );
    }
  };

  const handleClose = () => {
    onClose();
    setTimeout(()=> {
      setSubmitFeedbackError(false);
      setSubmitFeedbackLoading(false);
      setSubmitFeedbackSuccess(false);
      setDisplayResultState(false);
    }, 500);
  };

  const modalContent = (
    <div className={`modal-overlay ${closing ? "closing" : ""}`}>
      <div className={`modal ${closing ? "closing" : ""}`}>
        {!displayResultState &&<div>
          <p style={{ fontWeight: "bold", fontSize: "16px", alignSelf: "center" }}>
            {type === "up" ? t("feedback.positiveTitle") : t("feedback.negativeTitle")}
          </p>
          <p style={{ fontSize: "13px" }}>
            {t("feedback.helperText")}
          </p>
        </div>}
        <div className={`feedback-content ${contentFading ? "content-fading" : ""}`}>
          {displayResultState ?
            <div style={{
              border: "1px",
              borderRadius: "8px",
              alignItems: "center",
              marginTop: "10%"
            }}>
              <p style={{ fontSize: "14px", color: submitFeedbackError ? "red" : theme}}>
                { submitFeedbackSuccess ? 
                type === "up" ? 
                posFeedbackSuccessMessage ? posFeedbackSuccessMessage : t("feedback.positive_feedback_submit_success") :
                negFeedbackSuccessMessage ? negFeedbackSuccessMessage : t("feedback.negative_feedback_submit_success") :
                t("feedback.feedback_submit_error")
                }
              </p>
            </div>
            : (
              <>
                {Array.isArray(feedbackOptions) && feedbackOptions.length > 0 && (
                  <div className="feedback-options">
                    {feedbackOptions.map((option, idx) => (
                      <label className="feedback-option" key={idx}>
                        <input
                          type="radio"
                          name="feedback-option"
                          value={option}
                          checked={message === option}
                          onChange={() => setMessage(option)}
                          style={{ accentColor: theme }}
                        />
                        <span>{option}</span>
                      </label>
                    ))}
                  </div>
                )}
                <textarea
                  rows={5}
                  placeholder={type === "up" ? t("feedback.placeholderPositive") : t("feedback.placeholderNegative")}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </>
            )
          }
        </div>
        <div className="modal-actions">
          <button className="feedback-modal-btn" style={{ background: "#efefef" }} onClick={handleClose}>
            {t("feedback.close")}
          </button>
          {!(submitFeedbackSuccess || submitFeedbackError) && <button
            style={{ background: disabled ? "grey" : theme, color: "white" }}
            className="feedback-modal-btn"
            onClick={handleSubmit}
            disabled={disabled || submitFeedbackLoading}
          >
            {submitFeedbackLoading ? t("feedback.submitting") : t("feedback.submit")}
          </button>}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}